import React from "react";
import Footer from "../Footer/Footer";
import Navbar from "../Navbar/Navbar";

function Industrial() {
  const data = [
    {
      name: "Mamatqulov Zuxridin Urmonovich ",
      skill: "farmatsevtika fanlari bo’yicha falsafa doktori, PhD ",
      mail: "mzu_77@mail.ru",
      img: "/img/mamatqulovzuxriddin.jpg",
      phone: " 90-336-11-92"
    },
    {
      name: "Hayitboyev Jasur Abdusaminovich ",
      skill:
        "Sanoat farmatsiyasi fakulteti dekanining o’quv ishlari bo’yicha o’rinbosari ",
      mail: " real.jasur@mail.ru",
      img: "/img/jasurhayitboyev.jpg",
      phone: "99-875-17-80"
    },
    {
      name: "Pardayeva Maftuna Ilhomovna ",
      skill:
        "Sanoat farmatsiyasi fakulteti dekanining o’quv ishlari bo’yicha o’rinbosari ",
      mail: "maftuna.pardayeva@gmail.com",
      img: "/img/pardayevamaftuna.jpg",
      phone: " 90-336-11-92"
    },
    {
      name: "Obloqulov Jahongir Baxtiyor o’g’li  ",
      skill:
        "Sanoat farmatsiyasi fakulteti dekanining o’quv ishlari bo’yicha o’rinbosari",
      mail: "jahongir93obloqulov17@gmail.com",
      img: "/img/obloqulovjahongir.jpg",
      phone: "90-037-30-00"
    },
    {
      name: "Murotov Shaxbozmirzo Buvajon o’g’li ",
      skill:
        "Sanoat farmatsiyasi fakulteti dekanining o’quv ishlari bo’yicha o’rinbosari",
      mail: "Shoxboz.murotov@mail.ru",
      img: "/img/shahbozmurotov.jpg",
      phone: "90-548-75-99"
    }
  ];
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Navbar />
      <div className="custom__page">
        <div className="container">
          <div className="header__custom">
            <h4>Sanoat farmatsiyasi fakulteti </h4>
            {data.map((item) => (
              <div className="card__custom">
                <div className="box__custom">
                  <img src={item.img} alt />
                </div>
                <div className="box-1__custom">
                  <p> {item.name} </p>
                  <span> {item.skill} </span>
                  <br />
                  <br />
                  <hr />
                  <div className="wer__custom">
                    <div className="malinki__custom">
                      <p>E-pochta</p>
                      <span>{item.mail}</span>
                    </div>
                    <div className="malinki1__custom">
                      <p>Telefon nomer</p>
                      <span>{item.phone} </span>
                    </div>
                  </div>
                  <div className="wer__custom"></div>
                </div>
              </div>
            ))}
          </div>
          <div className="card1__custom">
            <p>
              Toshkent farmatsevtika instituti “Sanoat farmatsiyasi” fakultetini
              mustaqilligimiz mevasi deyishimiz mumkin. Chunki, mustaqillik
              farmatsevtika sohasining jadal sur’atlar bilan rivojlanishi uchun,
              sohada yangi yo‘nalishlarni tashkil etish zaruriyatini yuzaga
              keltirdi. Aslida, mustaqilligimizning birinchi yillarida dorivor
              o‘simliklarning xalq tabobati va farmatsevtika sanoatidagi
              ahamiyatini inobatga olib, 1992-yilda Toshkent farmatsevtika
              institutining farmatsiya fakulteti tarkibida “Agrobiotexnologiya”
              mutaxassisliklari tashkil qilingan va 1994-yil 2-sentabrida
              alohida “Agrobiotexnologiya” fakulteti sifatida ajralib chiqqan
              edi. Fakultet biotexnologiya va agronomiya yo‘nalishlari bo‘yicha
              oliy ma’lumotli kadrlar tayyorlar edi. Keyinchalik,
              respublikamizda Kadrlar tayyorlash Milliy dasturining qabul
              qilinishi, ta’lim sohasida, jumladan, farmatsevt kadrlar
              tayyorlash tizimini tubdan o‘zgarish va takomillashtirishni taqozo
              etdi. Bu esa, o‘z navbatida, institutda bir qator yangi ta’lim
              yo‘nalishlarini va magistratura mutaxassisliklarini tashkil
              qilinishiga asos bo‘ldi. Xususan, 2003–2004 o‘quv yilidan “Sanoat
              farmatsiyasi” – yo‘nalishining “Oliy ta’lim yo‘nalishlari va
              mutaxassisliklari klassifikatori”ga kiritilishi hamda dori
              vositalarini ishlab chiqaruvchi korxonalar uchun kadrlarni
              tayyorlashni yo‘lga qo‘yilishi natijasida 2003-yil 17-sentabr
              100-sonli institut buyrug‘i asosida “Agrobiotexnologiya” fakulteti
              nomi “Sanoat farmatsiyasi” fakulteti deb o‘zgartirildi
            </p>
            <p>
              Fakultetga hozirgi kunga qadar quyidagi professor – o‘qituvchilar
              rahbarlik qilganlar:
              <br />
              1)A.Abzalov (1994 – 1996 y.) – O‘zbekistonda xizmat ko‘rsatgan
              xalq ta’limi xodimi, dotsent
              <br />
              2)E.Ergashev (1996 – 1998 y.) – professor.
              <br />
              3)S.Nabiyev (1998 – 1999 y.) – professor.
              <br />
              4)I.Yo.Inog‘omov (1999 – 2001 y.) – dotsent.
              <br />
              5)N.Osmanov (2001 – 2005 y.) – dotsent.
              <br />
              6)A.A.Nurmuxamedov (2005 – 2015 y.) – dotsent.
              <br />
              7)X.Sh.Ilhomov (2015 – 2019 y.) – dotsent.
              <br />
              8)Z.U.Mamatqulov (2019 y. – hozirgi kunda ) – dotsent v.v.b.
              <br />
              2019-yil mart oyidan boshlab fakultetga Z.U.Mamatqulov rahbarlik
              qilmoqda. Fakultet dekani muovinlari sifatida M.I.Pardayeva,
              J.A.Hayitboyev, Sh.B.Muratov va J.B.Obloqulovlar samarali faoliyat
              olib bormoqdalar.
              <br />
              Sanoat farmatsiyasi fakulteti tarkibida “Sanoat farmatsiyasi”,
              “Farmatsevtik biotexnologiya” va 2015-2016 o‘quv yilidan boshlab
              yangi “Metrologiya, standartlashtirish va mahsulot sifati
              menejmenti (dori vositalari)” ta’lim yo‘nalishlari bo‘yicha
              kadrlar tayyorlash amalga oshiriladi. Ushbu ta’lim yo‘nalishlarini
              bitiruvchilari dori vositalarini ishlab chiqaruvchi korxonalarda
              faoliyat ko‘rsatishlari belgilangan. Ijtimoiy-iqtisodiy,
              ilmiy-texnikaviy muammolarni yuqori saviyada hal eta oladigan,
              malakali, raqobatbardosh kadrlarni tayyorlash respublikamizdagi
              Sanoat farmatsiyasi fakulteti oldida turgan ustuvor vazifa
              hisoblanadi.
              <br />
              <br />
              O’zbekiston Respublikasi Prezidentining va Vazirlar Mahkamasining
              oxirgi yillardagi qator qarorlari, qonunlari va buyruqlarida,
              Respublikamizda dori vositalarining ishlab chiqarish hajmini
              ko‘paytirish masalalari qo‘yilmoqda. Iqtisodiyotning ustuvor
              yo‘nalishlari bo‘yicha qabul qilingan konsepsiyada mahalliy dori
              vositalarining raqobatbardoshligini oshirish va eksport qilishga
              yo‘naltirilgan dori vositalarining ishlab chiqarish hajmini
              ilmiy-texnika yutuqlari va xalq xo‘jaligi bilan integratsiyasi
              asosida ko‘paytirish va sog‘liqni saqlash sohasini 50% gacha
              mahalliy dori vositalari bilan ta’minlash, buning uchun esa
              Respublikamiz har bir viloyatlarida dorivor o‘simliklarni
              yetishtirishni yo‘lga qo‘yish, shu bilan birga, farmatsevtika
              sohasini yuqori malakali kadrlar bilan ta’minlash choralari
              belgilangan.
              <br />
              <br />
              Sanoat farmatsiyasi fakulteti sanoat farmatsiyasi va farmatsevtik
              biotexnologiya yo‘nalishi bo‘yicha o‘qiydigan talabalar tayyor
              dori vositalari va fitopreparatlar texnologiyasi, biotexnologiya
              ixtisosligi bo‘yicha farmatsevt texnolog, farmatsevt biotexnolog
              kvalifikatsiyasini oladilar. Metrologiya, standartlashtirish va
              mahsulot sifati menejmenti (dori vositalari) ta’lim yo‘nalishi
              bitiruvchilari esa, dori ishlab chiqarish korxonalardagi
              asbob-anjomlar metrologiyasi va standartizatsiyasini nazorat
              qilib, dori vositari sifatiga javob berishadi.
              <br />
              <br />
              Hozirgi vaqtda professor-o‘qituvchilar tomonidan fakultetda 1261
              nafar talabaga ta’lim berib kelinmoqda. Talabalar 2-3 kurslarda
              qator umumkasbiy fanlar, jumladan farmatsevtik kimyo,
              farmakognoziya, amaliy mexanika fani asosida materiallar
              qarshiligi, mashina va mexanizmlar nazariyasi hamda mashina
              detallari, umumiy kimyoviy texnologiya, dori turlari texnologiyasi
              asosiy jarayonlari va uskunalari kabi muxandislik fanlari
              o‘qiganidan so‘ng yuqori kurslarda maxsus fanlar ishlab
              chiqarishni loyhalash, jihozlash, sanoat iqtisodiga oid dori
              vositalarini qadoqlash o’rash, sanoat farmatsiyasi, biofarmatsiya,
              farmatsevtik ishlab chiqarishni tashkil qilish, uning iqtisodiyoti
              hamda marketingi, biofaol moddalar texnologiyasi, dori
              vositalarini sifatini ta’minlash va boshqarish kabi zarur bo‘lgan
              mutaxassislik fanlari o‘qitiladi. Shu o‘rinda aytib o‘tish
              kerakki, 2021-2022 o‘quv yilidan boshlab fakultet negizida yangi
              “Farmatsevtik ishlab chiqarishni tashkil qilish va sifat
              menejmenti” mutaxassislik kafedrasi hamda “Organik sintez”
              kafedralari tashkil qilindi. To‘liq kursni tamomlagan talabalar
              dori sanoati uchun farmatsevt texnolog, farmatsevt biotexnolog,
              dori vositalarini ishlab chiqarish jarayonini, texnologik
              jarayonlarni standartlovchi va mahsulot sifatini boshqaruvchi
              farmatsevt metrologlar bo‘lib yetishadilar. Bundan tashqari,
              bitiruvchilar o‘quv yurtlari va ilmiy tadqiqot institutlarida
              ishlashlari mumkin. Shu bilan birga ushbu mutaxassisliklar
              bo‘yicha tayyorlangan bakalavrlar, Dorilarning sanoat
              texnologiyasi, dorivor o’simliklar biotexnologiyasi, farmatsevtik
              biotexnologiya va bioinjenering kabi magistratura
              mutaxassisliklarida o‘qishlarini davom ettirishlari mumkin.
              <br />
              <br />
              2021-2022 o‘quv yilidan boshlab Sanoat farmatsiyasi fakulteti
              tarkibida 8 ta kafedralar tashkil etildi. Ular quyidagicha:
              <br />
              <br />
              Dori vositalari sanoat texnologiyasi kafedrasi. Kafedra mudiri –
              farm.f.d., dotsent Maksudova Firuza Xurshidovna.
              <br />
              <br />
              Farmatsevtik ishlab chiqarishni tashkil qilish va sifat menejmenti
              kafedrasi. Kafedra mudiri farm.f.d., dotsent Yunusxodjayeva Nodira
              Abdulxamitovna.
              <br />
              <br />
              Biotexnologiya kafedrasi. Kafedra mudiri – b.f.b.f.d. Phd, -
              Usmanova Zakira Usmanovna.
              <br />
              Tibbiy va biologik fanlar kafedrasi. Kafedra mudiri t.f.n, dotsent
              Nuraliyeva Xafiza Otayevna.
              <br />
              Organik sintez kafedrasi. Kafedra mudiri b.f.n., dotsent Pulatova
              Feruza Azadbekovna.
              <br />
              Ijtimoiy fanlar kafedrasi. Kafedra mudiri i.f.n., dotsent Ismailov
              Kamolatdin Qurultayevich.
              <br />
              Fizika, matematika va AT kafedrasi. Kafedra mudiri f-m.f.n.,
              dotsent Abduraxmonov Baxromjon Alisherovich.
              <br />
              O’zbek tili va adabiyoti kafedrasi. Kafedra mudiri Abdullayeva
              Albina Ergashevna.
              <br />
              <br />
              Mazkur kafedralarda jami 20 ga yaqin fan doktorlari va
              professorlar, 40 dan ortiq fan nomzodlari va dotsentlar, 80 ga
              yaqin katta o‘qituvchi va assistentlar talabalarga bilim
              bermoqdalar. Fakultetga qarashli kafedralardagi barcha ta’lim
              yo‘nalishlarining o‘quv rejasidagi fanlar bo‘yicha o‘quv-uslubiy
              majmualar yaratilgan va institut axborot resurs markaziga
              joylashtirilgan. Barcha fanlar darslik va o‘quv qo‘llanmalar bilan
              ta’minlangan, bu darslik va o‘quv qo‘llanmalar kafedralar
              professor-o‘qituvchilar tamonidan ilg‘or horij adabiyotlari
              asosida yaratilayotgan yangi avlod o‘quv adabiyotlari bilan
              boyitilmoqda.
              <br />
              <br />
              Fakultetning sanoat farmatsiyasi, farmatsevtik biotexnologiya,
              metrologiya, standartlashtirish va mahsulot sifati menejmenti
              (dori vositalari) yo‘nalishlari bo‘yicha ixtisoslashgan
              kafedralari, respublikamizdagi oliy o‘quv yurtlari, yetakchi
              ilmiy-tekshirish institutlari, dori vositalarni ishlab chiqaruvchi
              korxonalar bilan innovatsion-korporativ hamkorlik dasturi asosida,
              ta’lim, fan va ishlab chiqarish integratsiyasini hisobga olgan
              holda o‘quv mashg‘ulotlari va amaliyotni o‘tkazib kelmoqdalar
              hamda o‘quv ishlari bilan birga ilmiy tadqiqot ishlari ham olib
              boriladi.
              <br />
              <br />
              Ta’lim sifatini oshirish maqsadida nazariy bilimlarni amaliyot
              bilan integratsiya qilish borasida fakultet kafedralari tomonidan
              talabalarning nafaqat malakaviy amaliyotlari, balki ba’zi dars
              jarayonlari ham respublikamizning ko’ga ko’ringan “Dentafill” XK,
              “Nika Farm” MChJ, “Meros” MChJ, “Temur Med Farm” MChJ, “Jo’rabek”
              MChJ, “Ziyonurfarm” QK, Mikrobiologiya instituti, Botanika bog‘i,
              O‘zFA qoshidagi “Genomika va bioinformatika markazi”, O‘zstandart
              agentligi qoshidagi Metrologiya va sertifikatlashtirish bo‘limi,
              Dori vositalarini standartlashtirish ilmiy markazi hamda boshqa
              ishlab chiqarish korxonalari va ilmiy tekshirish institutlarida
              o’tkazilib borilmoqda.
            </p>
          </div>
        </div>
        <div className="mt"></div>
      </div>
      <Footer />
    </div>
  );
}

export default Industrial;
